module.exports = __webpack_public_path__ + "img/zswd_select.d5926873.png";